import {
  KEEPER,
  CENTRE_BACK,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_RIGHT,
  FULL_BACK_LEFT,
  SWEEPER,
  WING_BACK_RIGHT,
  WING_BACK_LEFT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  CENTRE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_LEFT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  DEFENSIVE_MIDFIELD,
  OFFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  CENTRE_FORWARD_LEFT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD,
  WINGER_RIGHT,
  WINGER_LEFT,
  SECOND_STRIKER,
  STRIKER,
  STRIKER_RIGHT,
  STRIKER_LEFT,
} from '../../../typings/player';
import {
  FORMATION_442,
  FORMATION_433,
  FORMATION_451,
  FORMATION_532,
  FORMATION_541,
  FORMATION_343,
  FORMATION_352,
  FORMATION_4321,
  FORMATION_4411,
  FORMATION_4231,
  FORMATION_4222,
  FORMATION_3421,
  FORMATION_3412,
  FORMATION_3331,
  FORMATION_4132,
  FORMATION_4240,
  FORMATION_4312,
  FORMATION_4141,
  FORMATION_3511,
  FORMATION_3142,
  FORMATION_343D,
  FORMATION_3241,
  FORMATION_41212,
} from '../../../typings/formations';

import { IMatchFormationMap, IPlayerInFormation } from './match-formation';

const DEFAULT_MAXCHAR = {
  1: 30,
  2: 15,
  3: 15,
  4: 14,
  5: 11,
};

/**
 * FIELD formationPlaceS MAPs
 */
interface IFieldformationPlacesMap {
  [key: number]: IPlayerInFormation[];
}

const keeperMap: IFieldformationPlacesMap = {
  1: [{ left: '50%', top: '8%', formationPlace: KEEPER, maxCharLength: DEFAULT_MAXCHAR[1] }],
};

const standardBackMap: IFieldformationPlacesMap = {
  3: [
    { left: '25%', top: '30%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
    { left: '50%', top: '30%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[3] },
    { left: '75%', top: '30%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  ],
  4: [
    { left: '15%', top: '30%', formationPlace: FULL_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '38%', top: '30%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '62%', top: '30%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '85%', top: '30%', formationPlace: FULL_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  ],
  5: [
    { left: '15%', top: '30%', formationPlace: WING_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
    { left: '32.5%', top: '30%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
    { left: '50%', top: '30%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[5] },
    { left: '67.5%', top: '30%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
    { left: '85%', top: '30%', formationPlace: WING_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  ],
};

const standardMidfieldMap: IFieldformationPlacesMap = {
  2: [
    { left: '38%', top: '53%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
    { left: '62%', top: '53%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  ],
  3: [
    { left: '25%', top: '53%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
    { left: '50%', top: '53%', formationPlace: CENTRE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[3] },
    { left: '75%', top: '53%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  ],
  4: [
    { left: '15%', top: '53%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '38%', top: '53%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '62%', top: '53%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '85%', top: '53%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  ],
  5: [
    { left: '15%', top: '53%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
    { left: '32.5%', top: '53%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
    { left: '50%', top: '53%', formationPlace: CENTRE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[5] },
    { left: '67.5%', top: '53%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
    { left: '85%', top: '53%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  ],
};

const standardForwardMap: IFieldformationPlacesMap = {
  1: [{ left: '50%', top: '76%', formationPlace: CENTRE_FORWARD, maxCharLength: DEFAULT_MAXCHAR[1] }],
  2: [
    { left: '37.5%', top: '76%', formationPlace: CENTRE_FORWARD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
    { left: '62.5%', top: '76%', formationPlace: CENTRE_FORWARD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  ],
  3: [
    { left: '25%', top: '76%', formationPlace: WINGER_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
    { left: '50%', top: '76%', formationPlace: CENTRE_FORWARD, maxCharLength: DEFAULT_MAXCHAR[3] },
    { left: '75%', top: '76%', formationPlace: WINGER_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  ],
  4: [
    { left: '15%', top: '76%', formationPlace: WINGER_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '38%', top: '76%', formationPlace: CENTRE_FORWARD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '62%', top: '76%', formationPlace: CENTRE_FORWARD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
    { left: '85%', top: '76%', formationPlace: WINGER_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  ],
};

// 3xyz modules
export const schema3142 = [
  ...keeperMap[1],
  // 3
  { left: '25%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '28%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 1
  { left: '50%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 4
  { left: '15%', top: '61%', formationPlace: WING_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '61%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '61%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '61%', formationPlace: WING_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 2
  { left: '37.5%', top: '76%', formationPlace: STRIKER_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62.5%', top: '76%', formationPlace: STRIKER_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
];

export const schema3241 = [
  ...keeperMap[1],
  // 3
  { left: '25%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '28%', formationPlace: SWEEPER, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 2
  { left: '37.5%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62.5%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  // 4
  { left: '15%', top: '61%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '37.5%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62.5%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '61%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 1
  ...standardForwardMap[1],
];

export const schema3331 = [
  ...keeperMap[1],
  // 3
  { left: '25%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '28%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 3
  { left: '25%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 3
  { left: '25%', top: '61%', formationPlace: WINGER_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '61%', formationPlace: WINGER_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 1
  { left: '50%', top: '76%', formationPlace: CENTRE_FORWARD, maxCharLength: DEFAULT_MAXCHAR[1] },
];

export const schema3412 = [
  ...keeperMap[1],
  // 3
  { left: '25%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '28%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 4
  { left: '15%', top: '45%', formationPlace: WING_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '45%', formationPlace: WING_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 1
  { left: '50%', top: '60%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 2
  ...standardForwardMap[2],
];

export const schema3421 = [
  { left: '50%', top: '5%', formationPlace: KEEPER, maxCharLength: 30 },
  // 3
  { left: '25%', top: '25%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '25%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '25%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 4
  { left: '15%', top: '42%', formationPlace: WING_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '42%', formationPlace: DEFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '42%', formationPlace: DEFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '42%', formationPlace: WING_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 2
  { left: '62%', top: '59%', formationPlace: OFFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '38%', top: '59%', formationPlace: OFFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  // 1
  ...standardForwardMap[1],
];

export const schema343 = [...keeperMap[1], ...standardBackMap[3], ...standardMidfieldMap[4], ...standardForwardMap[3]];

export const schema343D = [
  ...keeperMap[1],
  // 3
  { left: '25%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '28%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 4
  { left: '50%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '15%', top: '53%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '53%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '50%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 3
  { left: '25%', top: '76%', formationPlace: WINGER_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '76%', formationPlace: STRIKER, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '76%', formationPlace: WINGER_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
];

export const schema3511 = [
  ...keeperMap[1],
  // 3
  { left: '25%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '28%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 5
  { left: '15%', top: '45%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '32.5%', top: '51%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '50%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '67.5%', top: '51%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '85%', top: '45%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  // 1
  { left: '50%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[1] },
  ...standardForwardMap[1],
];

export const schema352 = [
  ...keeperMap[1],
  ...standardBackMap[3],
  { left: '15%', top: '51%', formationPlace: WING_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '32.5%', top: '57%', formationPlace: DEFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '50%', top: '51%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '67.5%', top: '57%', formationPlace: DEFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '85%', top: '51%', formationPlace: WING_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  ...standardForwardMap[2],
];

// 4xyz modules
export const schema41212 = [
  { left: '50%', top: '5%', formationPlace: KEEPER, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 4
  { left: '15%', top: '24%', formationPlace: FULL_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '24%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '24%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '24%', formationPlace: FULL_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 1
  { left: '50%', top: '41%', formationPlace: DEFENSIVE_MIDFIELD, maxCharLength: 24 },
  // 2
  { left: '15%', top: '51%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: 16 },
  { left: '85%', top: '51%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: 16 },
  // 1
  { left: '50%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 2
  { left: '37.5%', top: '77%', formationPlace: STRIKER_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62.5%', top: '77%', formationPlace: STRIKER_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
];

export const schema4132 = [
  ...keeperMap[1],
  // 4
  { left: '15%', top: '28%', formationPlace: FULL_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '28%', formationPlace: FULL_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 1
  { left: '50%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 3
  { left: '25%', top: '61%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '61%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 2
  ...standardForwardMap[2],
];

export const schema4141 = [
  ...keeperMap[1],
  // 4
  { left: '15%', top: '28%', formationPlace: FULL_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '28%', formationPlace: FULL_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 1
  { left: '50%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 4
  { left: '15%', top: '61%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '61%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '61%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '61%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 1
  { left: '50%', top: '76%', formationPlace: STRIKER, maxCharLength: DEFAULT_MAXCHAR[1] },
];

export const schema4222 = [
  ...keeperMap[1],
  // 4
  { left: '15%', top: '28%', formationPlace: WING_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '28%', formationPlace: WING_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 2
  { left: '38%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  // 2
  { left: '38%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  // 2
  ...standardForwardMap[2],
];

export const schema4231 = [
  { left: '50%', top: '7%', formationPlace: KEEPER, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 4
  { left: '15%', top: '27%', formationPlace: FULL_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '27%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '27%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '27%', formationPlace: FULL_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 2
  { left: '38%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62%', top: '45%', formationPlace: DEFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  // 3
  { left: '20%', top: '61%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '80%', top: '61%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 1
  ...standardForwardMap[1],
];

export const schema4240 = [
  ...keeperMap[1],
  // 4
  ...standardBackMap[4],
  // 2
  { left: '38%', top: '50.5%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62%', top: '50.5%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  // 4
  { left: '15%', top: '70%', formationPlace: WINGER_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '70%', formationPlace: CENTRE_FORWARD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '70%', formationPlace: CENTRE_FORWARD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '70%', formationPlace: WINGER_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
];

export const schema4312 = [
  ...keeperMap[1],
  // 4
  { left: '15%', top: '28%', formationPlace: FULL_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '28%', formationPlace: FULL_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 3
  { left: '25%', top: '45%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '45%', formationPlace: CENTRE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '45%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 1
  { left: '50%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 2
  { left: '38%', top: '76%', formationPlace: WINGER_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62%', top: '76%', formationPlace: WINGER_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
];

export const schema4321 = [
  ...keeperMap[1],
  // 4
  { left: '15%', top: '28%', formationPlace: FULL_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '28%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '28%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '28%', formationPlace: FULL_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 3
  { left: '25%', top: '45%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '50%', top: '45%', formationPlace: CENTRE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[3] },
  { left: '75%', top: '45%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[3] },
  // 2
  { left: '38%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[2] },
  { left: '62%', top: '61%', formationPlace: OFFENSIVE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[2] },
  // 1
  ...standardForwardMap[1],
];

export const schema433 = [...keeperMap[1], ...standardBackMap[4], ...standardMidfieldMap[3], ...standardForwardMap[3]];

export const schema4411 = [
  { left: '50%', top: '5%', formationPlace: KEEPER, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 4
  { left: '15%', top: '25%', formationPlace: FULL_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '25%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '25%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '25%', formationPlace: FULL_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 4
  { left: '15%', top: '43.5%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '38%', top: '43.5%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '62%', top: '43.5%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  { left: '85%', top: '43.5%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[4] },
  // 1
  { left: '50%', top: '60%', formationPlace: SECOND_STRIKER, maxCharLength: DEFAULT_MAXCHAR[1] },
  // 1
  { left: '50%', top: '76%', formationPlace: CENTRE_FORWARD, maxCharLength: DEFAULT_MAXCHAR[1] },
];

export const schema442 = [...keeperMap[1], ...standardBackMap[4], ...standardMidfieldMap[4], ...standardForwardMap[2]];

export const schema451 = [
  ...keeperMap[1],
  ...standardBackMap[4],
  { left: '15%', top: '58%', formationPlace: SIDE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '32.5%', top: '52%', formationPlace: CENTRE_MIDFIELD_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '50%', top: '52%', formationPlace: CENTRE_MIDFIELD, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '67.5%', top: '52%', formationPlace: CENTRE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '85%', top: '58%', formationPlace: SIDE_MIDFIELD_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  ...standardForwardMap[1],
];

// 5xyz modules
export const schema532 = [
  ...keeperMap[1],
  { left: '15%', top: '35%', formationPlace: WING_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '32.5%', top: '29%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '50%', top: '29%', formationPlace: SWEEPER, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '67.5%', top: '29%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '85%', top: '35%', formationPlace: WING_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  ...standardMidfieldMap[3],
  ...standardForwardMap[2],
];

export const schema541 = [
  ...keeperMap[1],
  { left: '15%', top: '35%', formationPlace: WING_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '32.5%', top: '29%', formationPlace: CENTRE_BACK_RIGHT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '50%', top: '29%', formationPlace: CENTRE_BACK, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '67.5%', top: '29%', formationPlace: CENTRE_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  { left: '85%', top: '35%', formationPlace: WING_BACK_LEFT, maxCharLength: DEFAULT_MAXCHAR[5] },
  ...standardMidfieldMap[4],
  ...standardForwardMap[1],
];

/** EXPORTS */
export const formations: IMatchFormationMap = {
  [FORMATION_442]: schema442,
  [FORMATION_433]: schema433,
  [FORMATION_451]: schema451,
  [FORMATION_343]: schema343,
  [FORMATION_541]: schema541,
  [FORMATION_532]: schema532,
  [FORMATION_352]: schema352,
  // non standard modules
  [FORMATION_4321]: schema4321,
  [FORMATION_4411]: schema4411,
  [FORMATION_4231]: schema4231,
  [FORMATION_4222]: schema4222,
  [FORMATION_3421]: schema3421,
  [FORMATION_3412]: schema3412,
  [FORMATION_4132]: schema4132,
  [FORMATION_4240]: schema4240,
  [FORMATION_4312]: schema4312,
  [FORMATION_3331]: schema3331,
  [FORMATION_4141]: schema4141,
  [FORMATION_3511]: schema3511,
  [FORMATION_3142]: schema3142,
  [FORMATION_343D]: schema343D,
  [FORMATION_3241]: schema3241,
  [FORMATION_41212]: schema41212,
};
